<style>
    video {
        width: 100%;
    }
</style>

<template>
    <div class="animated fadeIn">

        <Request
                ref="request"
                method="GET"
                root="/virtual-event/room"
                :onRequestSuccess="onRequestSuccess">
            <slot slot="body">

                <b-row>
                    <b-col>
                        <h5>{{dataEventDate.title}}</h5>
                    </b-col>
                    <b-col class="text-right">
                        <b-button @click="disconnect" class="btn btn-danger mr-2"><i class="fa fa-times mr-2"></i>{{Core.Definition.getDefinition('Quitter la salle')}}</b-button>
                    </b-col>
                </b-row>
                <hr/>
                <b-row>
                    <b-col lg="8">
                        <b-card>
                            <div slot="header">
                                {{Core.Definition.getDefinition('Présentateur')}}
                            </div>
                            <div id="speaker"></div>
                            <b-alert v-if="dataSpeaker === false" show variant="light">
                                {{Core.Definition.getDefinition('Le présentateur n\'est pas en ligne.')}}
                            </b-alert>
                            <div v-if="dataCurrentUser.isSpeaker === true" slot="footer">
                                <b-button-group size="sm">
                                    <b-button @click="switchVideo" :class="{ 'btn-success':dataSettings.video === true, 'btn-danger':dataSettings.video === false }" class="btn mb-2"><i class="fa fa-video-camera"></i></b-button>
                                    <b-button @click="switchAudio" :class="{ 'btn-success':dataSettings.audio === true, 'btn-danger':dataSettings.audio === false }" class="btn mb-2"><i class="fa fa-microphone"></i></b-button>
                                </b-button-group>
                            </div>
                        </b-card>
                    </b-col>
                    <b-col lg="4">
                        <b-row v-if="dataCurrentUser.isSpeaker === false">
                            <b-col>
                                <b-card>
                                    <div slot="header">
                                        <b-badge class="badge-success"></b-badge>
                                        {{Core.Definition.getDefinition('Vous')}}
                                    </div>
                                    <div :id="'booking' + dataCurrentUser.id"></div>
                                    <div slot="footer">
                                        <b-button-group size="sm">
                                            <b-button @click="switchVideo" :class="{ 'btn-success':dataSettings.video === true, 'btn-danger':dataSettings.video === false }" class="btn mb-2"><i class="fa fa-video-camera"></i></b-button>
                                            <b-button @click="switchAudio" :class="{ 'btn-success':dataSettings.audio === true, 'btn-danger':dataSettings.audio === false }" class="btn mb-2"><i class="fa fa-microphone"></i></b-button>
                                        </b-button-group>
                                    </div>
                                </b-card>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col :key="bookingIndex" v-for="booking, bookingIndex in dataBookings" v-if="booking.userId.toString() !== dataCurrentUser.id.toString()" lg="6">
                                <b-card>
                                    <div slot="header">
                                        <sup>
                                            <b-badge v-if="dataBookings[bookingIndex].isConnected" pill variant="success">&nbsp;</b-badge>
                                            <b-badge v-if="dataBookings[bookingIndex].isConnected === false" pill variant="danger">&nbsp;</b-badge>
                                        </sup>
                                        {{booking.userFirstname}} {{booking.userLastname}}
                                    </div>
                                    <div :id="'booking' + booking.userId"></div>
                                    <div v-if="dataBookings[bookingIndex].isConnected === false" class="text-center text-muted">
                                        {{Core.Definition.getDefinition('Hors ligne')}}
                                    </div>
                                    <div v-if="dataBookings[bookingIndex].isConnected === true" class="text-center text-muted">
                                        {{Core.Definition.getDefinition('En ligne')}}
                                    </div>
                                </b-card>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>

            </slot>
        </Request>
    </div>
</template>

<script>
    const { connect, createLocalTracks } = require('twilio-video')
    const { createLocalVideoTrack } = require('twilio-video')
    import Request from '../../../components/Request'
    export default {
        name: 'VirtualEventRoom',
        components: {
            Request
        },
        mounted() {
            if (Core.Validation.isId(this.$route.params.eventDateId)) {
                let eventDateId = this.$route.params.eventDateId
                this.$refs.request.clearArgs()
                this.$refs.request.addArg('eventDateId', eventDateId)
                this.$refs.request.request()
            }
        },
        beforeDestroy() {
            if (this.dataRoom !== false) {
                this.dataRoom.disconnect()
            }
        },
        data() {
            return {
                Core: window.Core,
                dataBookings: [],
                dataEventDate: false,
                dataCurrentUser: false,
                dataSettings: {
                    audio: true,
                    video: true
                },
                dataSpeaker: false,
                dataRoom: false
            }
        },
        computed: {
        },
        watch: {
        },
        methods: {
            onRequestSuccess(data) {
                if (data.currentUser !== undefined) {
                    this.dataCurrentUser = data.currentUser
                }
                if (data.eventDate !== undefined) {
                    this.dataEventDate = data.eventDate
                }
                if (data.bookings !== undefined) {
                    this.dataBookings = data.bookings
                }

                this.initRoom()
            },
            switchAudio() {
                this.dataSettings.audio = !this.dataSettings.audio
            },
            switchVideo() {
                this.dataSettings.video = !this.dataSettings.video
            },
            connectionStatus(identity, connected) {
                let bookingId = identity.replace('booking', '')
                if (Core.Validation.isId(bookingId)) {
                    let bookingIndex = Core.Array.findIndexByKey(this.dataBookings, 'userId', bookingId)
                    if (bookingIndex !== false) {
                        this.dataBookings[bookingIndex].isConnected = connected
                    }
                }
            },
            disconnect() {
                this.dataRoom.disconnect()
            },
            initRoom() {
                if (this.dataCurrentUser.virtualToken !== undefined) {
                    connect(this.dataCurrentUser.virtualToken,
                        {
                            name: this.dataEventDate.title,
                            audio: this.dataSettings.audio,
                            video: this.dataSettings.video
                        }).then(room => {

                        this.dataRoom = room

                        console.log(`Successfully joined a Room: ${room}`)

                        let localParticipant = room.localParticipant;
                        console.log(`Connected to the Room as LocalParticipant "${localParticipant.identity}"`);
                        localParticipant.tracks.forEach(publication => {
                            if (localParticipant.identity.includes('speaker')) {
                                document.getElementById('speaker').innerHTML = ''
                                document.getElementById('speaker').appendChild(publication.track.attach());
                                this.dataSpeaker = publication
                            } else {
                                this.connectionStatus(localParticipant.identity, true)
                                document.getElementById(localParticipant.identity).innerHTML = ''
                                document.getElementById(localParticipant.identity).appendChild(publication.track.attach());
                            }
                        });

                        // Liste des participants connectés
                        room.participants.forEach(participant => {
                            console.log(`Participant "${participant.identity}" is connected to the Room`);

                            this.connectionStatus(participant.identity, true)

                            let mediaDivContainer = ''
                            if (participant.identity.includes('speaker')) {
                                mediaDivContainer = 'speaker'
                                this.dataSpeaker = participant
                            } else {
                                mediaDivContainer = participant.identity
                            }

                            document.getElementById(mediaDivContainer).innerHTML = ''
                            participant.tracks.forEach(publication => {
                                if (publication.isSubscribed) {
                                    let track = publication.track;
                                    document.getElementById(mediaDivContainer).appendChild(track.attach());
                                }
                            });
                            participant.on('trackSubscribed', track => {
                                document.getElementById(mediaDivContainer).appendChild(track.attach());
                            });
                        });

                        // Un nouveau participant se connect.
                        room.on('participantConnected', participant => {
                            console.log(`Participant "${participant.identity}" connected`);

                            this.connectionStatus(participant.identity, true)

                            let mediaDivContainer = ''
                            if (participant.identity.includes('speaker')) {
                                mediaDivContainer = 'speaker'
                                this.dataSpeaker = participant
                            } else {
                                mediaDivContainer = participant.identity
                            }

                            document.getElementById(mediaDivContainer).innerHTML = ''
                            participant.tracks.forEach(publication => {
                                if (publication.isSubscribed) {
                                    let track = publication.track;
                                    document.getElementById(mediaDivContainer).appendChild(track.attach());
                                }
                            });
                            participant.on('trackSubscribed', track => {
                                document.getElementById(mediaDivContainer).appendChild(track.attach());
                            });
                        });

                        room.on('disconnected', room => {
                            console.log('Successfully Disconnected')

                            this.connectionStatus(room.localParticipant.identity, false)

                            room.localParticipant.tracks.forEach(publication => {
                                let attachedElements = publication.track.detach();
                                attachedElements.forEach(element => element.remove());
                            });

                            let mediaDivContainer = ''
                            if (room.localParticipant.identity.includes('speaker')) {
                                mediaDivContainer = 'speaker'
                                this.dataSpeaker = false
                            } else {
                                mediaDivContainer = room.localParticipant.identity
                            }

                            document.getElementById(mediaDivContainer).innerHTML = ''
                        });

                        room.once('participantDisconnected', participant => {
                            console.log(`Participant "${participant.identity}" has disconnected from the Room`);

                            this.connectionStatus(participant.identity, false)

                            let mediaDivContainer = ''
                            if (participant.identity.includes('speaker')) {
                                mediaDivContainer = 'speaker'
                                this.dataSpeaker = false
                            } else {
                                mediaDivContainer = participant.identity
                            }
                            document.getElementById(mediaDivContainer).innerHTML = ''
                        });

                    }, error => {
                        console.error(`Unable to connect to Room: ${error.message}`);
                    });
                }
            }
        }
    };
</script>